<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.plannerGroupingList") }}</h1>

    <div v-if="groupingList.length > 0">
      <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="4" class="mt-2">
          <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
          <b-button variant="link" @click="resetTable()">{{
            $t("action.reset")
          }}</b-button>
        </b-col>
        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-2" v-if="teamSelect.length > 0">
        <b-col sm="4" class="mt-2">
          <b-button class="mt-2" variant="outline-success" @click="openmodal('confirmedTaskAssignment')">{{
            $t("action.assignTask") }}</b-button>
          <b-modal size="xl" id="confirmedTaskAssignment" :title="$t('title.taskAssignment')" hide-footer>
            <confirmedTaskAssignment :teamSelect="teamSelect" modalid="confirmedTaskAssignment" />
          </b-modal>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table id="plannerGroupingTable" stacked="lg" bordered :fields="myfields" :items="items"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
            <template v-slot:cell(edit)="row">
              <b-button variant="link" class="ml-2" size="sm" @click="openmodal('managePlannerGrouping', row.item)">{{
                $t("action.editPlannerGrouping") }}</b-button>
            </template>
            <template v-slot:cell(details)="row">
              <b-button :variant="row.item.variant" class="ml-2" size="sm" @click="chooseGroup(row.item)">{{
                $t("action.choose") }}</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="groupTable"></b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-row class="pt-4">
      <b-col class="mt-2">
        <b-button variant="success" @click="openmodal('managePlannerGrouping', null)">{{
          $t("action.managePlannerGrouping")
        }}</b-button>
      </b-col>
    </b-row>

    <b-modal id="managePlannerGrouping" :title="$t('action.managePlannerGrouping')" size="xl" hide-footer>
      <GroupAssignment :groupingItem="rowItem" modalid="managePlannerGrouping" />
    </b-modal>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import confirmedTaskAssignment from "./ConfirmedTaskAssignment.vue";
import GroupAssignment from "./GroupAssignment.vue";

export default {
  mixins: [globalF],
  data() {
    return {
      error: "",
      spinner: false,
      groupingList: [],
      sortBy: "Creation",
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      teamSelect: [],
      selectAll: false,
      selectOnt: false,
      selectBuilding: false,
      selectUser: false,
      taskList: [],
      taskSelect: null,
      rowItem: null,
      maxPlannerGroupLength: 26,
      groupType: null,
    };
  },
  mounted() {
    this.$root.$on("bv::modal::hide", () => {
      this.getPlannerGroupingList();
    });
    this.$store.commit("removeGroupMembersListTest", []);
    this.getPlannerGroupingList();
  },
  computed: {
    user: function () {
      return this.$store.getters.getGraphUser;
    },
    url: function () {
      return this.getUrl();
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.groupingList;
      let search = this.search.toLowerCase();
      return mydatalist.filter(
        (p) =>
          p.GroupingName.toLowerCase().includes(search)
      );

    },
    myfields: function () {
      return [
        {
          key: "GroupingName",
          sortable: true,
          label: this.$t("label.nameOfTheGroup"),
        },
        {
          key: "edit",
          label: this.$t("label.edit")
        },
        {
          key: "details",
          label: this.$t("action.choose")
        },
      ];
    }
  },
  methods: {
    resetTable: function () {
      this.search = "";
    },
    getPlannerGroupingList() {
      //this.teamSelect = [];
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getPlannerGroupingList" },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            let groupingList = response.data.groupingList;
            let teamSelect = this.teamSelect;
            this.groupingList = groupingList.map(g => {
              let find = teamSelect.find(t => t.Id === g.Id);
              if (find) {
                g.variant = "success"
              }
              else {
                g.variant = "outline-success";
              }
              return g;
            });
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    chooseGroup: function (group) {
      let tableInfo = this.groupingList;
      let teamSelect = this.teamSelect;

      let find = teamSelect.find((t) => t.Id === group.Id);
      if (find) {
        this.teamSelect = teamSelect.filter((t) => t.Id !== group.Id); //s'il est là je l'enlève
        this.groupingList = tableInfo.map((g) => {
          if (g.Id === find.Id) {
            g.variant = "outline-success"; //je remet le bouton outline-success
          }
          return g;
        });
      } else {
        this.teamSelect.push(group); //s'il n'est pas là je l'ajoute
        this.groups = tableInfo.map((g) => {
          if (g.Id === group.Id) {
            g.variant = "success"; //je met le bouton success
          }
          return g;
        });
      }
    },
    setNextPage(page) {
      this.$emit("changePage", page);
    },
    openmodal: function (id, rowItem) {
      this.rowItem = rowItem;
      this.$bvModal.show(id);
    },
  },
  components: {
    confirmedTaskAssignment,
    GroupAssignment
  },
};
</script>
